import React, { Component } from 'react';
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';

class CountdownTimer extends Component {
    constructor(props) {
        super(props);
        // this.uniqueId = `countdown-${Math.random().toString(36).slice(2, 11)}`;
        const initial = this.calculateCountdown(this.props.date);
        this.state = {
            timeLeft: this.calculateCountdown(this.props.date),
            // liveMessage: this.getLiveMessage(initial),
            // hasBeenAnnounced: false,  // Track whether the live message has been announced
        };
        this.lastAnnouncedMinute = initial.min;
    }

    componentDidMount() {
        // update every minute
        this.interval = setInterval(() => {
            const timeLeft = this.calculateCountdown(this.props.date);
            this.setState({ timeLeft });
            if (timeLeft.expired) {
                this.stop();
            }

            // if (timeLeft.min !== this.lastAnnouncedMinute) {
            //     const liveMessage = this.getLiveMessage(timeLeft);
            //     this.setState(prevState => {
            //         if (prevState.liveMessage !== liveMessage) {
            //             this.lastAnnouncedMinute = timeLeft.min;
            //             return { liveMessage };
            //         }
            //         return null;
            //     });
            // }
        }, 1000);
    }

    componentWillUnmount() {
        this.stop();
    }

    calculateCountdown(endDate) {
        let diff = (Date.parse(new Date(parseInt(endDate))) - Date.parse(new Date())) / 1000;

        const timeLeft = {
            expired: false,
            days: 0,
            hours: 0,
            min: 0,
            sec: 0
        };

        if (diff <= 0) {
            timeLeft.expired = true;
            return timeLeft;
        }

        // calculate time difference between now and expected date        
        if (diff >= 86400) { // 24 * 60 * 60
            timeLeft.days = Math.floor(diff / 86400);
            diff -= timeLeft.days * 86400;
        }

        if (diff >= 3600) { // 60 * 60
            timeLeft.hours = Math.floor(diff / 3600);
            diff -= timeLeft.hours * 3600;
        }

        if (diff >= 60) {
            timeLeft.min = Math.floor(diff / 60);
            diff -= timeLeft.min * 60;
        }

        timeLeft.sec = diff;

        return timeLeft;
    }

    stop() {
        clearInterval(this.interval);
    }

    addLeadingZeros(value) {
        value = String(value);
        while (value.length < 2) {
            value = '0' + value;
        }

        return value;
    }

    getLiveMessage(timeLeft) {
        return `${timeLeft.days} day${timeLeft.days !== 1 ? 's' : ''}, ` +
               `${timeLeft.hours} hour${timeLeft.hours !== 1 ? 's' : ''}, ` +
               `${timeLeft.min} minute${timeLeft.min !== 1 ? 's' : ''} remaining`;
      }

    render() {
        const snapshotMessage = this.getLiveMessage(this.state.timeLeft);
        const CountdownTimerColumn = ({ number, text }) => (
            <div>
                <div className={'eir-display-lg-3 display-4 eir-countdown-num  pb-1 '}>{number}</div>
                <div className="eir-countdown-text">
                    {text}
                </div>
            </div>
        );

        const CountdownSeparator = () => (
            <span className="mx-2 mx-md-3 pb-3 eir-display-lg-3 display-4 eir-countdown-num">:</span>
        );

        if (this.state.timeLeft.expired) {
            return (<div></div>);
        } else {
            return (
                <div className={this.props.className + ' countdown-timer position-relative'} >
                    <div className="visually-hidden">{snapshotMessage}</div>
                    <h6 className="eir-countdown-text pb-3">{this.props.title}</h6>
                    <div className="d-flex text-center justify-content-center justify-content-md-start" aria-hidden="true">
                        <CountdownTimerColumn number={this.addLeadingZeros(this.state.timeLeft.days)} text="Days" />
                        <CountdownSeparator />
                        <CountdownTimerColumn number={this.addLeadingZeros(this.state.timeLeft.hours)} text="Hours" />
                        <CountdownSeparator />
                        <CountdownTimerColumn number={this.addLeadingZeros(this.state.timeLeft.min)} text="Minutes" />
                        <CountdownSeparator />
                        <CountdownTimerColumn number={this.addLeadingZeros(this.state.timeLeft.sec)} text="Seconds" />

                    </div>
                    <button onClick={(e)=>this.props.onRemoveCDT(e)} aria-label="Close countdown timer" className="close-btn" ></button>
                </div>

            );
        }
    }
}

CountdownTimer.propTypes = {
    date: PropTypes.string,
    title: PropTypes.string
};

CountdownTimer.defaultProps = {
    date: new Date()
};

const currentDate = new Date();
const year = (currentDate.getMonth() === 11 && currentDate.getDate() > 23) ? currentDate.getFullYear() + 1 : currentDate.getFullYear();

export default CountdownTimer;